export const generateFTID = (offerId: string): string => {
  const now = new Date();

  // Format date as YYYY-MM-DD
  const year = now.getUTCFullYear();
  const month = (now.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = now.getUTCDate().toString().padStart(2, '0');
  const date = `${year}-${month}-${day}`;

  // Format time as HH:MM:SS
  const hours = now.getUTCHours().toString().padStart(2, '0');
  const minutes = now.getUTCMinutes().toString().padStart(2, '0');
  const seconds = now.getUTCSeconds().toString().padStart(2, '0');
  const time = `${hours}:${minutes}:${seconds}`;

  // Format: {leadId}:{YYYY-MM-DD}T{HH:MM:SS}
  return `${offerId}:${date}T${time}`;
};
